import { render, staticRenderFns } from "./aOwnerDetailCoupon.vue?vue&type=template&id=2546f0f7&scoped=true"
import script from "./aOwnerDetailCoupon.vue?vue&type=script&lang=js"
export * from "./aOwnerDetailCoupon.vue?vue&type=script&lang=js"
import style0 from "./aOwnerDetailCoupon.vue?vue&type=style&index=0&id=2546f0f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2546f0f7",
  null
  
)

export default component.exports